export enum PlayerConfigLogEvent {
  CLIP_FETCHED = 'CLIP_FETCHED',
  CLIP_AVAILABILITY_STATUS = 'CLIP_AVAILABILITY_STATUS',
  PLAYER_CONFIG_GENERATED = 'PLAYER_CONFIG_GENERATED',
  PLAYER_CONFIG_SKIPPED = 'PLAYER_CONFIG_SKIPPED',
  PLAYER_CONFIG_RESPONSE = 'PLAYER_CONFIG_RESPONSE',
  CLIP_PERSISTED = 'CLIP_PERSISTED',
  SPEAKERS_ANALYSIS_OUTBOUND = 'SPEAKERS_ANALYSIS_OUTBOUND',
  SPEAKERS_ANALYSIS_RESPONSE = 'SPEAKERS_ANALYSIS_RESPONSE',
  SPEAKERS_ANALYSIS_FAIL = 'SPEAKERS_ANALYSIS_FAIL',
  VIDEO_DURATION_FETCHED = 'VIDEO_DURATION_FETCHED',
  TRANSCRIPT_OUTBOUND = 'TRANSCRIPT_OUTBOUND',
  TRANSCRIPT_RESPONSE = 'TRANSCRIPT_RESPONSE'
}
